import { useState } from 'react';
import UserList from '../../components/admin/users/UserList';
import UserForm from '../../components/admin/users/UserForm';
import Button from '../../components/shared/UI/Button';

export default function UsersPage() {
  const [view, setView] = useState('list');
  const [selectedUser, setSelectedUser] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  function handleSaved() {
    setView('list');
    setSelectedUser(null);
    setRefreshKey(k => k + 1);
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>User Management</h1>
          <p>Create and manage portal user accounts and access permissions.</p>
        </div>
      </div>

      {view === 'list' && (
        <UserList
          key={refreshKey}
          onAdd={() => { setSelectedUser(null); setView('add'); }}
          onEdit={(user) => { setSelectedUser(user); setView('edit'); }}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedUser(null); }}>
              ← Back to Users
            </Button>
          </div>
          <div className="card">
            <div className="card-header">
              <h2>{view === 'add' ? 'Add New User' : `Edit: ${selectedUser?.full_name}`}</h2>
            </div>
            <div className="card-body">
              <UserForm
                user={view === 'edit' ? selectedUser : null}
                onSaved={handleSaved}
                onCancel={() => { setView('list'); setSelectedUser(null); }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
